// Base types

import { StatusType } from './Gene';
import { IOperon } from './LacOperon';

type Label = { label: string };
type Percent = { percent: number };
type Prefix = { prefix: string };
type Qualifier = { qualifier: string };
type GeneticType = { type: GeneType };
type DragAndDroppableType = { type: DragAndDropType };

export enum DragAndDropTypes {
  BacterialDNA = 'application/x.bacterial-dna',
  PlasmidDNA = 'application/x.plasmid-dna',
  Ecoli = 'application/x.ecoli',
}

export type DragAndDropType =
  | DragAndDropTypes.BacterialDNA
  | DragAndDropTypes.PlasmidDNA
  | DragAndDropTypes.Ecoli;

export enum GeneTypes {
  LacI = 'LacI',
  LacP = 'LacP',
  LacO = 'LacO',
  LacZ = 'LacZ',
  LacY = 'LacY',
  LacA = 'LacA',
}

export type GeneType =
  | GeneTypes.LacI
  | GeneTypes.LacP
  | GeneTypes.LacO
  | GeneTypes.LacZ
  | GeneTypes.LacY
  | GeneTypes.LacA;

export type ParsedOperon = {
  operon?: IOperon;
  output?: string;
  lacZ?: StatusType | null;
  lacA?: StatusType | null;
};

// Composite types

type LabelAndType = Label & DragAndDroppableType;

// Feature types

export type BacteriaInfo = LabelAndType;

export type GeneInfo = Label & Prefix & Percent & Qualifier & GeneticType;

export type OperonInfo = LabelAndType & Prefix;
